<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md6
      >
        <h1 style="text-align:center;font-weight:300;font-size:36px;">
          {{ app_name }}
        </h1>
        <br /><br />
        <div
          style="background: white;padding: 20px;border: 1px solid rgba(0,0,0,0.3);"
        >
          <v-card-text>
            <h2>Unknown Organization</h2>
            <div
              style="font-size: 16px;"
            >
              The website you entered doesn't match any known organizations. Please check the path and try again.<br /><br />
              <u>Make sure you've entered the website correctly - misspelling the website is a common mistake.</u>
            </div>
          </v-card-text>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorOrgNotFound'
}
</script>
